export interface Studio {
  subscriptionType: unknown;
  id?: number;
  fbSize?: number;
  fbSizeMax?: number;
  nameSignIn: string;
  fullName: string;
  logo: string;
  vat?: string;
  email?: string;
  telephone?: string;
  telephoneD?: string;
  website?: string;
  websiteD?: string;
  city?: string;
  province?: string;
  cap?: string;
  street?: string;
  streetNumber?: string;
  createdAt?: Date;
  updatedAt?: Date;
  subscribedEnd?: Date;
  patients?: string;
}

export const emptyStudio: Studio = {
  id: -1,
  nameSignIn: "",
  fullName: "",
  logo: "",
  subscriptionType: "",
};
